import BalanceTypeChangePopupContainer from './balance-type-change-popup-container'
import connector from './connector'

export default connector(BalanceTypeChangePopupContainer)
